"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getLang = getLang;

var _constants = require('../constants/');

function getLang() {
    var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ru';

    return {
        types: [_constants.TranslatePipoConstants.TRANSLATE_PIPO_REQUEST, _constants.TranslatePipoConstants.TRANSLATE_PIPO_SUCCESS, _constants.TranslatePipoConstants.TRANSLATE_PIPO_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getLang(lang);
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/actions/translate_pipo.js
// module id = 768
// module chunks = 0